(function() {
    'use strict';

    a3_cabin_reports.controller('GroundCourseCtrl', GroundCourseCtrl);
    /**
     * @memberof CabinReports
     * @ngdoc controller
     * @name GroundCourseCtrl
     * @description 
     *
     * @ngInject
     */
    function GroundCourseCtrl($route, $filter, $timeout, TrainingSessionFactory, CrewRouteFactory, FlightFactory, GroundDutyFactory, CourseFactory, $scope, $location, $routeParams) {
        $scope.gotoCourse = gotoCourse;
        $scope.gotoGroundDuty = gotoGroundDuty;
        $scope.stickySelectedTrainee = stickySelectedTrainee;
        $scope.toggleView = toggleView;

        $scope.refreshCourse = refresh;
        $scope.courseTrainees = [];

        var courseId = Number($routeParams.courseId);
        var groundDutyId = Number($routeParams.dutyId);
        var groundDuty = GroundDutyFactory.getGroundDutyFromStorage(groundDutyId);

        $scope.isEdit = false;
        $scope.loading = false;
        $scope.allAbsent = false;
        $scope.refreshSuccess = true; //show refresh icon

        if (!groundDuty) {
            // go to dashboard if no groundDuty
            $location.path("/");
        } else {
            var date = groundDuty.DutyDateS;

            if (groundDuty.RelatedGroundDuties) {
                var courses = GroundDutyFactory.getGroundDutyActiveCourses(groundDutyId);
                if (courses.length) {
                    CourseFactory.getCourseFromStorage(courseId, function(dutyCourse) {
                            $scope.dutyCourse = dutyCourse;
                            initCourse(false);
                        });
                }
            }
            $scope.groundDuty = groundDuty;
            $scope.groundDutyId = groundDutyId;
        }


        function initCourse(afterRefresh) {
            var courseId = $scope.dutyCourse.Id;
            TrainingSessionFactory.getSession(courseId, date, groundDutyId, afterRefresh, function(course) {
                if (course && !course.HasLimitedInfo) {
                    $scope.availableCourse = true;

                    $scope.selectedPhase = course.selectedPhase;
                    $scope.trainees = course.CourseTrainees; //only eligible trainees
                    course.SequenceWarning = false;
                }

                $scope.course = course;

                manageCourseStatus($scope.dutyCourse, course, afterRefresh);
                toggleView('History'); //default

                if ($scope.trainees) {
                    applyAttendanceFromGroundDuty(groundDuty, $scope.trainees);
                    stickySelectedTrainee();
                    if($scope.trainees.length && !$scope.trainees.some(x => !x.Session.Absent)){
                        $scope.allAbsent = true;
                    }

                    //Check for status change (new trainees found on a submitted session (reset) || failed certificate trainees want to retake the test)
                    if (afterRefresh && $scope.isCourseComplete && $scope.trainees.length) {
                        GroundDutyFactory.setCoursePending(groundDutyId, courseId);
                        $scope.isCourseComplete = false;
                        $route.reload();
                    }
                }

                $scope.reload = false;
                $timeout(function() {
                    $scope.reload = true;
                }, 100);

            });
        }

        function applyAttendanceFromGroundDuty(groundDuty, trainees){
            groundDuty.Trainees.forEach(function(related){
                related.CrewMembers.forEach(function(crew){
                    var trainee = trainees.find(x => x.CrewId == crew.Id);
                    if(trainee){
                        trainee.Session.Absent = crew.Absent;
                    }
                });
            });
        }

        function gotoCourse(course) {
            $location.path('/course/' + course.Id + '/' + groundDuty.DutyDateS + "/" + groundDuty.Id);
        }

        function refresh() {
            $scope.loading = true;

            if ($scope.isOffline) {
                $timeout(function() {
                    $scope.loading = false;
                }, 100);
                $scope.refreshSuccess = false;
                $scope.availableCourseInfo = false;
                $scope.refreshErrorMsg = "Online mode is required in order to get course. Please connect to the internet and try again.";
            } else {
                CourseFactory.updateCourseInfo($scope.dutyCourse.Id, groundDutyId, function() {
                        $scope.loading = false;
                        $scope.refreshSuccess = true;
                        $scope.availableCourseInfo = true;

                        initCourse(true);
                        $scope.reload = false;
                        $timeout(function() {
                            $scope.reload = true;
                        }, 100);

                    },
                    function() {
                        $scope.loading = false;
                        $scope.refreshSuccess = false;
                        $scope.availableCourseInfo = false;
                        $scope.refreshErrorMsg = "Something went wrong! Please Try again.";
                    },
                    function(error) {
                        console.log(error);
                        $scope.loading = false;
                        $scope.refreshSuccess = false;
                        $scope.availableCourseInfo = false;

                        $scope.refreshErrorMsg = "Oops! Something went wrong!";

                        //null exception!
                        // if (error.data.errorMessage) {
                        //     $scope.refreshErrorMsg = error.data.errorMessage;
                        // }
                    }
                )
            }
        }


        function manageCourseStatus(dutyCourse, course, afterRefresh) {
            // COMPLETED : has been submitted
            var isCourseComplete = courses.find(x => x.CourseId == dutyCourse.Id && x.Status == "Completed") != null;

            // NEEDS SUBMIT : 1 hour has passed since the end of the course
            var now = moment.utc();
            if (!dutyCourse.IsCompleted) {
                var needsSubmit = false;
                var fetched = moment.utc(groundDuty.DutyEnd);
                var duration = moment.duration(now.diff(fetched)).asHours();
                if (duration > 1) {
                    needsSubmit = true;
                }
            }

            // LIMITED : no info available
            var isCourseLimited = !course || course.HasLimitedInfo || (course.HasLimitedSession && !afterRefresh);

            // OUTDATED : NeedsRefresh || 18 hours since last refresh
            var isCourseOutdated = false;
            if (course && course.FetchedTime) {
                var now = moment.utc();
                var fetched = moment.utc(course.FetchedTime);
                var duration = moment.duration(now.diff(fetched)).asHours();

                if (duration > 18 || course.NeedsRefresh) {
                    isCourseOutdated = true;
                }
            }

            // ADDITIONAL TRAINING : One trainee, at least, is under additional training
            var hasAdditionalTrainingRequest = false;
            // if (course.selectedPhase.NeedsAdditionalTraining)       
            //     hasAdditionalTrainingRequest = true; 
            //     course.hasAdditionalTrainingRequest = true;

            $scope.headerMsg = "Refresh Course";
            if (isCourseLimited) $scope.headerMsg = "Fetch Course";


            $scope.hasPendingTraining = !isCourseComplete;
            $scope.hasUnsetTraining = needsSubmit;
            $scope.isCourseLimited = isCourseLimited;
            $scope.isCourseComplete = isCourseComplete;
            $scope.isCourseOutdated = isCourseOutdated;
            $scope.hasNotifications = isCourseLimited || isCourseOutdated || isCourseComplete;
            $scope.hasAdditionalTrainingRequest = hasAdditionalTrainingRequest;
        }

        function gotoGroundDuty() {
            $location.path('/groundDuty/' + groundDutyId);
        }

        function stickySelectedTrainee(){
            var availableRelease = $scope.selectedPhase.ModuleType=="Check" || !$scope.trainees.filter(x => !x.Session.Absent).some(tr => tr.Session.Items.some(i => i.Status == "Pending"));
            var individualGrading = $scope.trainees && $scope.trainees.filter(x => !x.Session.Absent).length && $scope.selectedPhase && 
                                    ( ($scope.selectedPhase.Syllabus && $scope.selectedPhase.Syllabus.IsGradable) 
                                     || $scope.selectedPhase.HasDayGrading 
                                     || ($scope.selectedPhase.HasReleaseGrading && availableRelease)
                                     ||  RequiresTraineeSignature());

            if(individualGrading){
                if($scope.trainees.filter(x => !x.Session.Absent).find(x => x.Session.selected)){
                    $scope.selectedTrainee = $scope.trainees.filter(x => !x.Session.Absent).find(x => x.Session.selected);
                }
                else{
                    $scope.selectedTrainee = $scope.trainees.filter(x => !x.Session.Absent)[0];
                }
            }
            else{
                $scope.selectedTrainee = null;
            }

            if($scope.selectedTrainee) $scope.selectedTraineeBadge = {CrewId:$scope.selectedTrainee.CrewId};
        }

        function RequiresTraineeSignature(){
            // End of session signature
            var endOfSessionSignature = $scope.selectedPhase.DayGrading.TraineeSignature;

            // End of module signature
            var endOfModuleSignature = $scope.course.ReleasedPhase && $scope.selectedPhase.ReleaseGrading.TraineeSignature;

            return endOfSessionSignature || endOfModuleSignature;
        }

        function toggleView(mode){
            $scope.viewMode = mode;
        }
    }
})();